import { CustomerCount } from '@/interfaces/chat';
import { CustomerInfo, CustomerListItem, GetCustomerListParams } from '@/interfaces/customer';
import request from '@/utils/request';

export const getCustomerList = (data: GetCustomerListParams) => {
  return request<{ list: CustomerListItem[] }>({ url: '/v1/customer/list', method: 'POST', data });
};

/** 获取用户详情 */
export const getCustomerDetail = (customerId: string) => {
  return request<CustomerInfo>({
    url: '/v1/customer/detail',
    method: 'GET',
    params: { customerId },
  });
};
/** 领取 */
export const receive = (customerId: string) => {
  return request({ url: '/v1/customer/receive', method: 'POST', data: { customerId } });
};
/** 释放 */
export const release = (customerId: string) => {
  return request({ url: '/v1/customer/release', method: 'POST', data: { customerId } });
};
/** 归档 */
export const archiveCustomer = (customerId: string, v: boolean) => {
  return request({ url: '/v1/customer/archive', method: 'POST', data: { customerId, archive: v } });
};

export const toggleAiStatus = (customerId: string, enableAi: boolean) => {
  return request({
    url: '/v1/customer/ai-status',
    method: 'PUT',
    data: { customerId, enableAi },
  });
};

export const autoOpenAiStatus = (customerId: string) => {
  return request.keepAliveFetch('/v1/customer/ai_status', { customerId, enableAi: true });
};

export const getCustomerCount = () => {
  return request<CustomerCount>({ url: '/v1/customer/count', method: 'GET' });
};

export const bindCustomerTag = (data: { customerId: string; tagIds: number[] }) => {
  return request({ url: '/v1/customer/bind-tags', method: 'POST', data });
};
export const unbindCustomerTag = (data: { customerId: string; tagIds: number[] }) => {
  return request({ url: '/v1/customer/unbind-tags', method: 'POST', data });
};

export const updateCustomerInfo = (
  customerId: string,
  data: Partial<Omit<CustomerInfo, 'customer_id'>>,
) => {
  return request({
    url: '/v1/customer/update',
    method: 'PATCH',
    data: { customerId, ...data },
  });
};

export const changeReceptionType = (data: {
  customerId: string;
  receptionType: 'workflow' | 'ai_agent' | 'manual';
}) => {
  return request({
    url: '/v1/customer/change-reception-type',
    method: 'POST',
    data,
  });
};
